import BeneficiaryUnionPayForm from "./steps/SubForms/BeneficiaryUnionPayForm";
import SenderBankForm from "./steps/SubForms/SenderBankForm";
import UnionPayPaymentDetailsForm from "./steps/SubForms/UnionPayPaymentDetailsForm";
import SenderUnionPayForm from "./steps/SubForms/SenderUnionPayForm";
import BankAccountPaymentDetails from "./steps/SubForms/BankAccountPaymentDetails";
import BusinessSenderForm from "./steps/SubForms/BusinessSenderForm";
import BeneficiaryBusinessForm from "./steps/SubForms/BeneficiaryBusinessForm";
import BusinessPaymentDetailsForm from "./steps/SubForms/BusinessPaymentDetailsForm";
import AliPaySenderForm from "./steps/SubForms/AliPaySenderForm";
import AliPayBeneficiaryForm from "./steps/SubForms/AliPayBeneficiaryForm";
import WeChatBeneficiaryForm from "./steps/SubForms/WeChatBeneficiaryForm";
import WeChatPaymentDetailsForm from "./steps/SubForms/WeChatPaymentDetailsForm";
import ReviewDetails from "./steps/SubForms/ReviewDetails";
import BankAccountBeneficiary from "./steps/SubForms/BankAccountBeneficiary";

export const formRegistry = {
  sender: {
    unionpay: SenderUnionPayForm,
    alipay: AliPaySenderForm,
    wechatpay: AliPaySenderForm,
    bank_account_individual: SenderBankForm,
    bank_account_business: BusinessSenderForm,
  },
  beneficiary: {
    unionpay: BeneficiaryUnionPayForm,
    alipay: AliPayBeneficiaryForm,
    wechatpay: WeChatBeneficiaryForm,
    bank_account_individual: BankAccountBeneficiary,
    bank_account_business: BeneficiaryBusinessForm,
  },
  payment: {
    unionpay: UnionPayPaymentDetailsForm,
    wechatpay: WeChatPaymentDetailsForm,
    bank_account_individual: BankAccountPaymentDetails,
    bank_account_business: BusinessPaymentDetailsForm,
  },

  review: {
    unionpay: ReviewDetails,
    alipay: ReviewDetails,
    wechatpay: ReviewDetails,
    bank_account_individual: ReviewDetails,
    bank_account_business: ReviewDetails,
  },
};
